import { fulfilled, pending, rejected } from '../../../utils';
import { FIND_ACCOUNT } from '../../actions/actiontype';

const initialState = {
	status: '',
	loading: false,
	message: '',
	data: '',
	error: '',
};

const findAccountReducer = (state = initialState, action) => {
	switch (action.type) {
		case pending(FIND_ACCOUNT):
			return {
				...state,
				loading: true,
				message: '',
				error: '',
			};
		case fulfilled(FIND_ACCOUNT):
			return {
				...state,
				loading: false,
				status: action.payload.data.status,
				message: action.payload.data.message,
				data: action.payload.data.data,
				error: '',
			};
		case rejected(FIND_ACCOUNT):
			return {
				...state,
				loading: false,
				message: '',
				error: status ===500 ? "Something went wrong. Please try again later" : action?.payload?.response.data.message,
			};
		default:
			return state;
	}
};

export default findAccountReducer;
